import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const CmsLayoutSidebarContainer = styled.div`
  display: none;
  float: left;
  position: sticky;
  top: 99px;
  left: 90px;
  max-width: 200px;
  width: calc(100vw / 8);
  z-index: 3;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: block;
  }
`;
